export default "__VITE_ASSET__r7B_Rcoa__"